import { createFileRoute } from '@tanstack/react-router'
import { AuditTrail } from '../components/AuditTrail.js'

export const Route = createFileRoute('/_app/audit-trail/')({
  component: AuditTrailPage,
})

function AuditTrailPage() {
  return (
    <AuditTrail
      endpoint="/api/v1/audit-logs"
      queryKey={['audit-logs']}
      title="Activity"
      description="Every write and communication in your academy, with who did it and when."
    />
  )
}
